import http from 'hub-http/clients/apiClient';
export const fetchCallDisposition = () => {
  return http.get('/twilio/v1/custom-dispositions/');
};